import InputField from './Input';

export default InputField;
